export default __webpack_public_path__ + "static/media/photo_gallery_5.ddfc5a0c.png";